module.exports = __webpack_public_path__ + "img/section1Swiper4.67e2bcbf.png";